import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";
import { Timeline } from "../../components/Timeline";
import { Instances } from "./Instances";
import { Contacts } from "./Contacts";
import { Chatbot } from "./ChatBot";
import { Groups } from "./Groups";
import { useStyles } from "./styles";
import { useEffect, useMemo } from "react";

export function WhatsApp() {
  const location = useLocation();
  const styles = useStyles();

  const TABS = [
    {
      label: "Números vinculados",
      index: 0,
      children: <Instances />,
    },
    {
      label: "Contatos",
      index: 1,
      children: <Contacts instanceId={location.state?.instanceId} />,
    },
    {
      label: "Grupos",
      index: 2,
      children: <Groups instanceId={location.state?.instanceId} />,
    },
    {
      label: "Chatbot",
      index: 3,
      children: <Chatbot />,
    },
  ];

  const defaultTab = useMemo(() => {
    if (!location.state) {
      return 0;
    } else {
      if (location.state.isGroup) {
        return 2;
      } else {
        return 1;
      }
    }
  }, [location.state]);

  useEffect(() => {
    window.history.replaceState({}, document.title);
  }, []);

  return (
    <Stack spacing={2} >
      <Stack className={styles.root} width="100%">
        <Typography variant="h6">WhatsApp</Typography>
        <Typography variant="body2">
          Vincule seu número de Whatsapp a Datasales.
        </Typography>
      </Stack>

      <Timeline
        defaultTab={defaultTab}
        tabs={TABS}
        padding={"0px"}
        propsTabHeader={{
          marginRight: 0,
          marginLeft: "2.5rem",
        }}
      />
    </Stack>
  );
}
